var render = function render(){var _vm=this,_c=_vm._self._c;return _c('payment-dropdown-export',{staticClass:"export",on:{"eventExportXLSX":_vm.downloadXLSX,"eventExportPDF":_vm.downloadPDF}})
}
var staticRenderFns = []

export { render, staticRenderFns }